import React, { useState } from 'react'
import { IoIosArrowForward } from "react-icons/io";
import { FaSearch } from "react-icons/fa";
import { Link } from 'react-router-dom';


function ClinttreeList() {

    const data = [
  { name: "blueberry1 ( [ T = 4903.1160 | P = 4903.1160 ])"  },
  { name: "Zoope_Retail ( [ T = 71.1800 | P = 71.1800 ])"  },
  { name: "BBGDMCC ( [ T = 0 | P = 0 ])"  },
  { name: "Gurpreet ( [ T = 0 | P = 0 ])" },
  { name: "Abiee ( [ T = 0 | P = 0 ])"  },
  { name: "Pradeep ( [ T = 0 | P = 0 ])"  },
  { name: "NH_Dubai ( [ T = 4998.1600 | P = 4998.1600 ])"  }
  
];

const [ Usersearch , setUsersearch ] = useState('')
 
const filterusers = data.filter((item)=>(
    item.name.toLocaleLowerCase().includes(Usersearch.toLocaleLowerCase())
))
    return (
        <>
        <div className='w-[100%] pt-[80px] px-4 dark:bg-[#121519] h-[100vh]'>
            <div className='w-[100%] p-5 rounded-xl shadow-[0_5px_15px_rgba(0,0,0,0.15)] '>
                <div className='border-b-[1px] border-[#cfcdcd] pb-1 '>
                    <h1 className='text-[#000] font-semibold text-[20px] dark:text-[#fff]'>Client Tree List</h1>
                    <div className='text-[#454546] dark:text-[#fff] text-[12px] font-semibold flex items-center cursor-pointer'>  <span>Home</span> <IoIosArrowForward />
                        <span>Client Tree List</span> </div>
                </div>
                <div className='border-b-[1px] border-[#cfcdcd] pb-1 pt-2'>
                    <div className='border-[1px] border-[#cfcdcd] max-w-[500px] p-2 rounded-md flex items-center gap-2'>
                       <div className='text-[12px] text-[#cfcdcd]'>
                          <FaSearch />
                       </div>
                          <input type="text"
                          placeholder='Search users'
                          className='w-[100%] outline-none text-[#cfcdcd] text-[12px] dark:text-[#fff] dark:bg-[#121519]'
                          value={Usersearch} 
                          onChange={(e)=>{
                            setUsersearch(e.target.value)
                          }}
                          />
                    </div>
                </div>
             <div className=''>
                {filterusers.map((item ,index)=>(
                <div className='flex items-center gap-2 mt-2 w-[100%] hover:scale-[1.02]'>
                     <div className='w-[4px] h-[4px] rounded-full bg-[#000] dark:bg-[#fff]'>
                     </div> 
                     <div className='h-[30px] border-l-[2px] border-[#178543] w-[100%] hover:bg-[#f1f8ff] hover:dark:bg-[#121519] hover:dark:text-[#178543]   flex items-center   '>
                        <Link to='/Admin/UserManagement/Index'>
                       <p className='text-[13px] font-semibold ml-2 dark:text-[#fff]'>{item.name}</p>
                       </Link>
                     </div>
                     </div>
                ))

                }
             </div>
            </div>
            
</div>
        </>
    )
}

export default ClinttreeList
